module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        _vm.toggleSidebar({
          opened: !_vm.sidebar.opened
        })
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sidebar.hidden),
      expression: "!sidebar.hidden"
    }],
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/samsung.svg"),
      "alt": _vm.pkginfo.description
    }
  }), _vm._v(" "), _c('tooltip', {
    attrs: {
      "label": 'v' + _vm.pkginfo.version,
      "placement": "right",
      "type": "success",
      "size": "small",
      "no-animate": true,
      "always": true,
      "rounded": true
    }
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('span', {
    staticClass: "vue"
  }, [_vm._v("Home IoT")]), _c('strong', {
    staticClass: "admin"
  }, [_vm._v(" Reference Server " + _vm._s(_vm.stage))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex"
  }, [(!_vm.$auth.check()) ? _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.login('facebook')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Login with OAuth2")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:user",
      arg: "user"
    }],
    class: _vm.btnClass
  }, [_vm._v("Welcome " + _vm._s(_vm.username()))]) : _vm._e(), _vm._v(" "), (_vm.$auth.check()) ? _c('popover', {
    attrs: {
      "name": "user"
    }
  }, [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('ul', {
    staticClass: "menu-item"
  }, [(_vm.isAdmin) ? _c('li', [_vm._v("Logged-in as an admin")]) : _vm._e(), _vm._v(" "), (_vm.isDev) ? _c('li', [_vm._v("Logged-in as a Developer")]) : _vm._e(), _vm._v(" "), (!_vm.isAdmin && !_vm.isDev) ? _c('li', [_vm._v("Logged-in as a Resident")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "button button-menu is-danger is-small",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")])])])])]) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fab"
  })])
}]}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55bccd5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"_CLIENT_ID_PLACE_HOLDER_","replace":"lfms21abk334e3i1lnkpr70ep"},{"search":"_BASE_API_PLACE_HOLDER_","replace":"https:/homeiottf-dev.auth.ap-northeast-2.amazoncognito.com"},{"search":"_CALLBACK_URL_HOLDER_","replace":"https:/www.homeiottf.com"}]}!./client/components/layout/Navbar.vue